export default __webpack_public_path__ + "static/media/photo_5282747746622312926_y.7391095e.jpg";